import React, { useState, useEffect } from "react";
import {
    Button,
    Modal,
    Box,
    TextField,
    Typography,
    Autocomplete,
} from "@mui/material";
import { useLazyQuery } from "@apollo/client";
import { GET_ALL_VENUES_WITH_NAME_FILTER } from "../../AddTickets/api/addTicketsQuery";
import { getAutocompleteStyles } from "../../../style/getAutoCompleteStyles";
import { Venue } from "../../../helper";
import { useDebounce } from "../../../hooks/useDebounce";

const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    borderRadius: 2,
    boxShadow: 24,
    p: 4,
};

interface EditVenueModalProps {
    open: boolean;
    onClose: () => void;
    onUpdate: (venue: Venue) => void;
    initialVenue: any; // name of the venue being edited
}

export default function EditVenueModal({
    open,
    onClose,
    onUpdate,
    initialVenue,
}: EditVenueModalProps) {
    const [inputValue, setInputValue] = useState('');
    const debouncedValue = useDebounce(inputValue, 500);
    const [venue, setVenue] = useState<Venue | null>(initialVenue.all_venue);
    const [listOfVenue, setlistOfVenue] = useState<Venue[]>([]);
    const [searchVenue, setsearchVenue] = useState<Venue | null>(null);
    const [getlistOfVenue, {loading}] = useLazyQuery(GET_ALL_VENUES_WITH_NAME_FILTER, {
            fetchPolicy: "no-cache",
            onCompleted: (data) => {
                setlistOfVenue(data?.all_venues);
            },
            onError: (err) => {
                console.log("Error at GetlistOfVenue", err?.message)
            }
        });

    // Reset state when modal opens
    useEffect(() => {
        if (open) {
            setVenue(initialVenue.all_venue);
            setsearchVenue(initialVenue.all_venue);
        }
    }, [open, initialVenue]);

    const handleUpdate = () => {
        if (!searchVenue) return;
        onUpdate(searchVenue);
        onClose();
    };
    const handlesearchVenue = async (_event: any, value: any) => {
        if(value){
            setsearchVenue(value);
        }
    }
    const handleInput = (_event: any, value: string) => {
        setInputValue(value); // just update state
    };
    useEffect(() => {
        if (debouncedValue.length >= 3) {
            getlistOfVenue({
                variables: { name: `${debouncedValue}%` },
            });
        }
    }, [debouncedValue]);
    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={style}>
                <Typography variant="h6" mb={2}>
                    Edit Venue
                </Typography>
                {/* <TextField
                    fullWidth
                    label="Venue Name"
                    value={venue?.av_name}
                    // onChange={(e) => setVenue(e.target.value)}
                    margin="normal"
                /> */}
                <div>
                    <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        sx={getAutocompleteStyles(true)}
                        options={listOfVenue ?? []}
                        loading={loading}
                        value={searchVenue}
                        onChange={handlesearchVenue}
                        onInputChange={handleInput}
                        autoHighlight
                        getOptionLabel={(option: Venue) =>
                            [[
                                option.av_name,
                                option.av_street,
                                option.av_city,
                                option.av_state_code,
                                option.av_country_code,
                                option.av_zipcode,
                            ]
                                .filter(Boolean)
                                .join(', '), option.av_venue_ref_id].join(" - ")
                        }
                        isOptionEqualToValue={(option: Venue, value: Venue) => option.av_id === value.av_id}
                        getOptionKey={(option: Venue) => option.av_id}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                placeholder="Select Venue"
                                InputLabelProps={{ shrink: true }}
                            />
                        )}
                    />
                </div>
                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    sx={{ mt: 2 }}
                    onClick={handleUpdate}
                    disabled={!searchVenue || searchVenue?.av_id === venue?.av_id}
                >
                    Update
                </Button>
            </Box>
        </Modal>
    );
}
